import React, { Component } from 'react';
import Header from '../../components/Header';
import PageHeader from '../../components/PageHeader';
import GutschriftProductTable from './GutschriftProductTable';
import Row from 'react-bootstrap/lib/Row';
import { connect } from 'react-redux';
import { fetchClients } from '../../actions/clientsActions';
import { fetchBrands } from '../../actions/brandsActions';
import { Button as AntdButton, message } from 'antd';
import { Cookies } from 'react-cookie';
import axios from 'axios';
const cookies = new Cookies();
var token = cookies.get('token');

const mapStoreToProps = (store) => {
    return {
        clients: store.clients.clients,
        products: store.products.products,
        brands: store.brands.brands,
    };
};

class Gutschrift extends Component {

  	state = {
        title: 'AOI Gutschrift',
        storageDownloadListUrl : '',

        loading: false,
        apiMore: '', // 加载更多API
        moreLoaded: false, // 是否还有更多数据
        error: false,
        data: [],
  	}

  	componentDidMount () {
		document.title = this.state.title;
        this.props.dispatch(fetchClients());
		this.props.dispatch(fetchBrands());
        this.getProducts(1, 0, new Date().getFullYear(), null);
    }

    getProducts = (need_gutschrift, received_gutschrift, year, brand_id) => {
        // this.props.dispatch(fetchProductsByGutschrift(need_gutschrift, received_gutschrift, year));
        axios.get(window.api + 'product/filterGutschrift/' + need_gutschrift + '/' + received_gutschrift + '?brand_id=' + brand_id + '&year=' + year + '&token=' + token, {
        })
            .then((response) => {
                // const { data } = response.data.products;
                const apiMore = response.data.products.next_page_url;
                // const dataMore = this.state.data.concat(data);
                this.setState({
                    data: response.data.products.data,
                    apiMore,
                    loading: false,
                    moreLoaded: false,
                    error: false,
                });
            })
            .catch(function (error) {
                message.error(error.response.data.errors);
            });
    }

    loadMore = () => {
        this.setState({
            loading: true,
        });
        axios.get(this.state.apiMore + '&token=' + token, {
        })
            .then((response) => {
                const { data } = response.data.products;
                const apiMore = response.data.products.next_page_url;
                const dataMore = this.state.data.concat(data);
                this.setState({
                    data: dataMore,
                    apiMore,
                    loading: false,
                    moreLoaded: true,
                    error: false,
                });
            })
            .catch(function (error) {
                message.error(error.response.data.errors);
            });
    }

  	render () {
        const { history, clients, products, brands } = this.props;

	    return (
	      	<div className="App">
	        	<Header history={history}/>
	        	<div id="page-wrapper">

	  				<div className="container-fluid">
	        			<PageHeader title={this.state.title}/>
                        
                        <Row>

                            <div className="col-lg-12">
                                
                                <GutschriftProductTable 
                                    brands={brands}
                                    clients={clients}
                                    products={this.state.data} 
                                    getProducts={this.getProducts.bind(this)} 
                                    storageDownloadListUrl={this.state.storageDownloadListUrl}
                                />
                                
                                <br />
                                {this.state.apiMore && (
                                    <div className="text-center">
                                        <AntdButton
                                            onClick={this.loadMore}
                                            shape="round"
                                            loading={this.state.loading}
                                        >
                                            加载更多
                                        </AntdButton>
                                    </div>
                                )}

                                {this.state.apiMore === null && this.state.moreLoaded === true && (
                                    <div className="text-center">
                                        <p>所有数据已加载完毕</p>
                                    </div>
                                )}
                                <br />
                                
                            </div>

                            <div className="col-lg-4">
                                                                  
                            </div>

                        </Row>

	        		</div>

	        	</div>
	      	</div>
	    );
  	}
}

export default connect(mapStoreToProps)(Gutschrift);
